import { useEffect, useMemo, useState } from 'react';

import masterDataService from '../service/masterData.service';
import useMenus from '../context/MenuContext';
import useParam from '../context/ParamContext';
import useUsers from '../context/UsersContext';
import { generateAutocompleteItems } from '../utils/helper';
import useConfig from '../context/ConfigContext';

export const useSimpleTask = () => {
  const { menus, getMenus, getMenuSubMenuId, getSubMenuNamesByUrls, getCanEdit, getCanCopy, getCanDelete } = useMenus();
  const { getParam, params } = useParam();
  const { getUser, user } = useUsers();
  const { getConfig } = useConfig();
  const [refetchTable, setRefetchTable] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [submenu, setSubmenu] = useState(null);
  const [canEdit, setCanEdit] = useState(true);
  const [canCopy, setCanCopy] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [dynLoading, setDynLoading] = useState(true);
  const isLoading = loading || dynLoading;
  const [dynProps, setDynProps] = useState([]);

  const [autocompleteData, setAutocompleteData] = useState({});
  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    type: [],
    status: [],
    resourceGroup: [],
    classification: [],
    company: [],
    resourceTwo: [],
  });

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .typeToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .statusToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .groupToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .projectToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .usersToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .priorityToForm(submenu)
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceOneToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceFiveToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyLocationToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .resourceTwoToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          type: resp[0],
          status: resp[1],
          resourceGroup: resp[2],
          project: resp[3],
          user: resp[4],
          priority: resp[5],
          resourceOne: resp[6],
          machine: resp[7],
          companylocation: resp[8],
          company: resp[9],
          resourceTwo: resp[10],
        };
        setAutocompleteData(aData);

        const filteredProject = aData.project.filter((p) => p.active);

        const acOptions = {
          type: generateAutocompleteItems(aData.type.typeItems, 'itemName', 'itemId'),
          status: generateAutocompleteItems(aData.status.statusItems, 'itemName', 'itemId'),
          resourceGroup: generateAutocompleteItems(aData.resourceGroup.projectGroupListitems, 'itemName', 'itemId'),
          project: generateAutocompleteItems(filteredProject, ['projectName', 'orderNumber'], 'projectId'),
          user: generateAutocompleteItems(aData.user, 'userName', 'userId'),
          priority: generateAutocompleteItems(aData.priority.priorityListItems, 'itemName', 'itemId'),
          resourceOne: generateAutocompleteItems(aData.resourceOne, 'name', 'id'),
          machine: generateAutocompleteItems(aData.machine, 'machineName', 'machineId'),
          companylocation: generateAutocompleteItems(aData.companylocation, 'name', 'id'),
          company: generateAutocompleteItems(aData.company, 'name', 'id'),
          resourceTwo: generateAutocompleteItems(aData.resourceTwo, 'name', 'id'),
        };
        setAutoCompleteOptions(acOptions);
        setLoading(false);
      })
      .finally(() => {
        //hideLoader();
      });
  };

  useEffect(() => {
    getMenus();
    getParam();
    if (!Object.keys(user).length) getUser();
    getConfig();
  }, []);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('simpleTask');
    setSubmenu(submenuId);
    setCanEdit(getCanEdit(submenuId));
    setCanCopy(getCanCopy(submenuId));
    setCanDelete(getCanDelete(submenuId));
  }, [menus]);

  useEffect(() => {
    submenu && initDefaultValues();
  }, [submenu]);

  const submenuNames = useMemo(() => {
    return getSubMenuNamesByUrls(['resourceOne', 'resourceTwo', 'resourceThree', 'resourceFour', 'machine']);
  }, [menus]);

  return {
    refetchTable,
    setRefetchTable,
    viewField,
    setViewField,
    selectedValues,
    setSelectedValues,
    operatorsDisabled,
    setOperatorsDisabled,
    submenu,
    submenuNames,
    params,
    canEdit,
    autocompleteData,
    autocompleteOptions,
    loading,
    canCopy,
    canDelete,
    editButtonVisible,
    setEditButtonvisible,
    rowSelectionModel,
    setRowSelectionModel,
    dynLoading,
    setDynLoading,
    isLoading,
    dynProps,
    setDynProps,
  };
};
